import React from 'react';

import { useMediaQuery } from '@mui/material';
import classNames from 'classnames/bind';
import { useSelector } from 'react-redux';

import { BREAK_POINTS } from '@common/constants/breackpoints';
import { HorizontalMenu } from '@components/HorizontalMenu';

import { getVisibleMenuItems } from '../../store';

import styles from './MainMenu.module.css';

const cn = classNames.bind(styles);

export function MainMenu() {
  const isTabletMax = useMediaQuery(`(max-width: ${BREAK_POINTS.screenTabletMax})`);

  const visibleMenuItems = useSelector(getVisibleMenuItems);

  if (isTabletMax) {
    return null;
  }

  return <HorizontalMenu className={cn('main-menu')} menuItemList={visibleMenuItems} />;
}
